module.exports = __webpack_public_path__ + "img/img13.1917e103.jpg";